// eslint-disable-next-line import/no-cycle
import { getUserData } from '@/auth/utils'
import { USER_TYPE_SCHOOL } from '@/const/userType'

export default function schoolUsersOnly({ next, router }) {
  if (getUserData().usertype !== USER_TYPE_SCHOOL && getUserData().usertype !== 'super') {
    return router.push('not-authorized')
  }

  return next()
}
